import React from 'react';

const UserProfile: React.FC = () => {
  return (
    <div className="flex items-center gap-2 cursor-pointer bg-gray-100 rounded-full px-2 py-1">
      <img
        src="https://i.pravatar.cc/40"
        alt="user"
        className="w-9 h-9 rounded-full object-cover"
      />

      <div className="hidden lg:block">
        <p className="text-xs font-semibold text-gray-800">
          Fabricio
        </p>
        <p className="text-xs text-gray-400">
           Admin
        </p>
      </div>
    </div>
  );
};

export default UserProfile;